import React from 'react';
import { Alert, Box, Button, Typography } from '@mui/material';
import { useGetData } from '../../services/hooks/useGetData';
import { tokens } from '../../theme';

export default function LowStockBanner({ onView }) {
    const { data: envelope } = useGetData(
        'ingredients/low-stock',
        {},
        null,
        null,
        null,
        { refetchInterval: 60_000 }
    );

    const count = envelope?.data?.count || 0;
    if (!count) return null;

    return (
        <Box sx={{ px: 2, pt: 1.5 }}>
            <Alert
                severity="warning"
                sx={{
                    bgcolor: tokens.warnBg,
                    color: 'text.primary',
                    border: '1px solid',
                    borderColor: 'divider',
                    '& .MuiAlert-icon': { color: tokens.warn },
                }}
                action={
                    <Button
                        color="inherit"
                        size="small"
                        onClick={() => onView?.()}
                        sx={{ fontWeight: 700 }}
                    >
                        View
                    </Button>
                }
            >
                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                    {count} raw ingredient{count === 1 ? '' : 's'} at or below reorder threshold
                </Typography>
            </Alert>
        </Box>
    );
}
